export default {
  props: ['titulo', 'mensaje', 'callback', 'aceptar', 'cancelar', 'callback2'],
  name: 'Confirmation',
  methods: {
    cancel() {
      if (typeof this.callback2 === 'function') {
        console.log('Aqui va el segundo callback');
        this.callback2(); // Ejecuta la función si existe
      }
      this.hide();
    },
    hide() {
      this.$bvModal.hide('confirmation-modal');
    },
    confirm() {
      this.callback();
      this.hide();
    },
  },
  mounted() {
    this.$root.$on('bv::modal::hide', () => {
      this.$destroy(); // cleanup in component
      this.$el.remove();
    });
  },
};
